import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { ISelfDisclosureLandingPage, IFetchDataPayload } from "@/selfdisclosure.interfaces";

import SelfDisClosureQuery from "@/graphql/SelfDisclosureLandingPage";

/**
 * @returns {ISelfDisclosureLandingPage}
 * @description
 * State defaults
 */
function stateDefaults(): ISelfDisclosureLandingPage {
    return {
        available: false,
        error: "",
        salesType: "REMOTE_SALES",
        data: {
            type: "",
            gender: "",
            firstName: "",
            lastName: "",
            phone: "",
            birthday: "",
            birthName: "",
            nationality: "",
            birthCountry: "",
            birthPlace: "",
            civilStatus: "",
            street: "",
            streetNumber: "",
            zipCode: "",
            city: "",
            region: null,
            country: "",
            residingSince: "",
            occupationType: "",
            employer: "",
            employmentSince: "",
            monthlyNetIncome1: 0,
            monthlyNetIncome2: 0,
            monthlyNetIncome3: 0,
            monthlyNetIncomePartner: 0,
            monthlyIncomeRenting: 0,
            monthlyIncomeOther: 0,
            iban: "",
            bic: "",
            bank: ""
        },
        info: {
            requiresOverviewPage: true,
            requiresTermsPage: true,
            offer: {
                term: 0,
                mileage: 0,
                monthlyRateTotal: 0,
                specialPayment: 0,
                contractType: ""
            },
            vehicle: {
                name: "",
                imageUrl: "",
                horsePower: ""
            }
        }
    };
}

@Module({ namespaced: true, name: "SelfDisclosureStore" })
export default class SelfDisclosure extends VuexModule {
    data: ISelfDisclosureLandingPage = stateDefaults();

    error = "";
    isLoading = false;

    get getInfo() {
        return this.data.info;
    }

    get getOffer() {
        if (!this.data || !this.data.info) {
            return null;
        }

        return this.data.info.offer;
    }

    get getVehicle() {
        return this.data.info.vehicle;
    }

    get getData() {
        return this.data.data;
    }

    get getFullDisclosure() {
        return this.data;
    }

    get getSalesType() {
        return this.data.salesType;
    }

    @Mutation
    setFullDisclosure(payload: ISelfDisclosureLandingPage) {
        this.data = { ...this.data, ...payload };
    }

    @Mutation
    setError(payload: string) {
        this.error = payload;
    }

    @Mutation
    setLoading(payload: boolean) {
        this.isLoading = payload;
    }

    @Mutation
    reset() {
        const defaultData = stateDefaults();
        this.data = { ...this.data, ...defaultData };
        this.error = "";
        this.isLoading = false;
    }

    @Action({ rawError: true })
    fetchData({ apollo, variables }: IFetchDataPayload) {
        this.context.commit("setLoading", true);

        return apollo.query({
            query: SelfDisClosureQuery,
            variables
        }).then(({ data: { selfDisclosureLandingPage } }: { data: { selfDisclosureLandingPage: ISelfDisclosureLandingPage } }) => {
            if (selfDisclosureLandingPage.data) {
                delete selfDisclosureLandingPage.data.__typename;

                // fix stupid bug for now
                if (!("region" in selfDisclosureLandingPage.data)) {
                    selfDisclosureLandingPage.data.region = null;
                }
            }

            this.context.commit("setLoading", false);
            this.context.commit("setFullDisclosure", selfDisclosureLandingPage);

            return selfDisclosureLandingPage;
        }).catch((error: Error) => {
            this.context.commit("setLoading", false);
            this.context.commit("setError", error);
        });
    }
}
